<div
  class="ibc-application-header {{ isOverlayOpened ? 'overlay-opened' : '' }}">
  <div class="header-container" title="PACTrak">
    <img src="assets/Logo.svg" alt="" />
    <div class="user-info-section">
      <div class="user-basic-info">
        <span class="ibc-body-text-large-bold">{{
          userFirstName | titlecase
        }}</span>
        <span class="ibc-body-table-text-small">{{ userLocation }}</span>
      </div>
      <span
        [matMenuTriggerFor]="menu"
        class="user-info-avatar ibc-heading-h4"
        >{{ userIntial }}</span
      >
      <mat-menu #menu="matMenu" class="app-header-menu">
        <mat-card class="user-info-card" appearance="outlined">
          <mat-card-header>
            <div mat-card-avatar class="user-avatar">
              <span>{{ userIntial }}</span>
            </div>
            <mat-card-title class="ibc-body-text-large-bold">{{
              userFullName | titlecase
            }}</mat-card-title>
            <mat-card-subtitle class="ibc-body-table-text-small">{{
              userLocation
            }}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-actions>
            <button mat-button (click)="redirectToUserProfile()">
              My Profile
            </button>
          </mat-card-actions>
        </mat-card>
      </mat-menu>
      <app-svg-icon
        class="header-section header-badge"
        [iconName]="'bell'"
        [isStaticSvg]="true"
        [isFrom]="'Page'"
        matTooltip="Notifications"
        aria-controls="view_notifications"
        [matMenuTriggerFor]="notificationsMenu"
        [matBadge]="unreadNotificationCount > 0 ? unreadNotificationCount : null"
        matBadgeOverlap="false"
        matBadgeSize="medium"
        (click)="onNotificationBellClick($event)"
        (keydown)="$event.stopPropagation()"></app-svg-icon>
      <mat-menu #notificationsMenu="matMenu" class="app-header-notifications-menu"  (closed)="onNotificationMenuClosed()">
        <div class="notification-card">
          <div class="header">
            <span>Notifications</span>
            <span class="mark-all-read" 
            (click)="markAllAsRead($event)"
            (keydown)="$event.stopPropagation()"
            [class.disabled]="unreadNotificationCount === 0">Mark all as read</span>
          </div>
          <div class="content">
            <div *ngIf="isLoadingNotifications" class="notification-item center-content">
              <span class="ibc-body-text-dark">Loading notifications...</span>
            </div>
            <div *ngIf="!isLoadingNotifications && notificationData.length === 0" class="notification-item center-content">
              <span class="ibc-body-text-dark">No notifications available</span>
            </div>
            <ng-container *ngFor="let notification of notificationData">
              <div class="notification-item">
                <div>
                  <div class="icon">
                    <app-svg-icon
                      class="header-section"
                      [iconName]="'bellMd'"
                      [isStaticSvg]="true"
                      [isFrom]="'Page'"></app-svg-icon>
                  </div>
                  <div class="notification-content">
                    <span class="title ibc-body-text-dark">{{ notification.notification }}</span>
                    <span class="time ibc-body-text-small-light">{{ notification.createdDate | date:'medium' }}</span>
                  </div>
                </div>
                <div class="notification-status">
                  <div *ngIf="!notification.isSeen" class="notification-dot"></div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-menu>
      <app-svg-icon
        class="header-section"
        [iconName]="'logout'"
        [isStaticSvg]="true"
        [isFrom]="'Page'"
        matTooltip="Logout"
        (click)="logout()"
        (keydown)="$event.stopPropagation()"
        aria-controls="logout"></app-svg-icon>
    </div>
  </div>
</div>
